import createIcon from '../../createIcon';

/**
 * @component @name Audiotrack
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTEuNSAzVjEyLjI4QzExLjAzIDEyLjExIDEwLjUzIDEyIDEwIDEyQzcuNTEgMTIgNS41IDE0LjAxIDUuNSAxNi41QzUuNSAxOC45OSA3LjUxIDIxIDEwIDIxQzEyLjMxIDIxIDE0LjIgMTkuMjUgMTQuNDUgMTdIMTQuNVY2SDE4LjVWM0gxMS41WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Audiotrack = createIcon('Audiotrack', [
  [
    'path',
    {
      d: 'M11.5 3V12.28C11.03 12.11 10.53 12 10 12C7.51 12 5.5 14.01 5.5 16.5C5.5 18.99 7.51 21 10 21C12.31 21 14.2 19.25 14.45 17H14.5V6H18.5V3H11.5Z',
      key: '1eiw3e',
    },
  ],
]);

export default Audiotrack;
